import { getLegacyBridge } from "./state";
import { LOCALE_CHANGE_EVENT } from "./i18n";
import {
  applyAuthSourceSelection,
  authSourceDetailText,
  currentAuthSource,
  handleAuthSourceClick,
  isDirectApiMode,
  refreshHealth,
  renderAuthSource,
  setAuthSource,
  sourceLabel,
} from "./auth-source";
import {
  setModeSettingsVariant,
  setModeSpecificElementVisibility,
  updateModeSpecificSettings,
} from "./api-mode-settings";
import {
  activeApiProvider,
  addProviderBinding,
  addApiProvider,
  apiModeLabel,
  backendForAuthSource,
  closeApiSettingsModal,
  codexModeLabel,
  currentApiImageModel,
  currentApiImagesConcurrency,
  currentApiMode,
  currentApiProviderId,
  currentApiProviderLabel,
  currentCodexMode,
  confirmDeleteApiProvider,
  copyApiProvider,
  deleteApiProvider,
  editApiProvider,
  hideApiKeyReveal,
  handleProviderBindingEditorChange,
  mergeApiProviderKeys,
  normalizeApiImagesConcurrency,
  normalizeApiProvider,
  normalizeApiSettings,
  openGenerationProviderSettings,
  openApiSettingsModal,
  persistApiSettings,
  populateApiSettingsForm,
  queueApiSettingsAutosave,
  readApiSettingsForm,
  revealApiKeyWhilePressed,
  renderApiProviderList,
  refreshApiSettings,
  restoreApiSettings,
  cancelApiProviderEdit,
  saveApiSettings,
  saveApiProviderEdit,
  selectApiProvider,
  selectCodexMode,
  setApiKeyRevealVisible,
  setApiSettingsFeedback,
  syncCodexModeNotes,
  taskApiProviderId,
  taskApiProviderLabel,
  taskBackendLabel,
  taskBackendValue,
  moveApiProvider,
  removeProviderBinding,
  toggleApiProviderSortMode,
  updateApiKeyRevealButton,
  updateApiRequestEndpointPreview,
} from "./api-provider-settings";

let apiSettingsFeatureInitialized = false;

export function initApiSettingsFeature(): void {
  if (apiSettingsFeatureInitialized) return;
  apiSettingsFeatureInitialized = true;
  document.addEventListener(LOCALE_CHANGE_EVENT, () => {
    const bridge = getLegacyBridge();
    renderAuthSource(bridge.state.authStatus);
    if (!bridge.els.systemSettingsModal?.classList.contains("hidden") && !bridge.els.systemSettingsApiPanel?.hidden) {
      setApiSettingsFeedback("", "");
    }
  });
  Object.assign(getLegacyBridge().methods, {
    refreshHealth,
    setAuthSource,
    handleAuthSourceClick,
    renderAuthSource,
    applyAuthSourceSelection,
    authSourceDetailText,
    sourceLabel,
    currentAuthSource,
    isDirectApiMode,
    setModeSpecificElementVisibility,
    setModeSettingsVariant,
    updateModeSpecificSettings,
    normalizeApiProvider,
    normalizeApiImagesConcurrency,
    normalizeApiSettings,
    activeApiProvider,
    addProviderBinding,
    restoreApiSettings,
    persistApiSettings,
    mergeApiProviderKeys,
    refreshApiSettings,
    populateApiSettingsForm,
    queueApiSettingsAutosave,
    readApiSettingsForm,
    currentApiProviderId,
    currentApiProviderLabel,
    addApiProvider,
    confirmDeleteApiProvider,
    copyApiProvider,
    deleteApiProvider,
    editApiProvider,
    hideApiKeyReveal,
    handleProviderBindingEditorChange,
    cancelApiProviderEdit,
    saveApiProviderEdit,
    selectApiProvider,
    selectCodexMode,
    setApiKeyRevealVisible,
    updateApiKeyRevealButton,
    updateApiRequestEndpointPreview,
    revealApiKeyWhilePressed,
    renderApiProviderList,
    syncCodexModeNotes,
    moveApiProvider,
    removeProviderBinding,
    toggleApiProviderSortMode,
    openGenerationProviderSettings,
    openApiSettingsModal,
    closeApiSettingsModal,
    currentApiImageModel,
    currentApiMode,
    currentCodexMode,
    currentApiImagesConcurrency,
    apiModeLabel,
    codexModeLabel,
    backendForAuthSource,
    taskBackendValue,
    taskApiProviderId,
    taskApiProviderLabel,
    taskBackendLabel,
    setApiSettingsFeedback,
    saveApiSettings,
  });
}
